import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {CommonService} from 'src/app/shared/utils/common.service';
import {moduloHorasExtras} from "../diccionarios/horas-extrasModulo";

@Injectable({
  providedIn: 'root'
})
export class ReplicaMarcionesService {

  diccionarioModulo: any;
  url: string;

  constructor(
    private http: HttpClient,
    private _util: UtilsService,
    private _commom: CommonService
  ) {
    this.diccionarioModulo = moduloHorasExtras;
    this.url = this._util.getUrlHorasExtra();
  }


  getAllEmployeesByDepartment(payload) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.getAllEmployeesByDepartment + payload.department);
  }

  getAllEmployees() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.getAllEmployees);
  }

  getAllDepartment() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.getAllDepartment);
  }

  getAllByEmployees(payload) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.replicaMarcacion.getAllByEmployees + payload.id + '?fechaFin=' + payload.endDate + '&fechaInicio=' + payload.startDate);
  }

  getAllByDepartment(payload) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.replicaMarcacion.getAllByDepartment + '?departmentCode=' + payload.department + '&fechaFin=' + payload.endDate + '&fechaInicio=' + payload.startDate);
  }

  guardarMarcacion(payload) {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.create, payload);
    //return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.update, payload);
  }

  actualizarMarcacion(payload) {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.update + payload.id, payload);
    //return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.update, payload);
  }
}
